import * as React from "react";
import { Typography } from "@mui/material";
import Container from "@mui/material/Container";

import Accordion, { accordionClasses } from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails, {
  accordionDetailsClasses,
} from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Fade from "@mui/material/Fade";
import grassrootImg from "../../images/fringe-events/grassroot.png";
import masterImg from "../../images/fringe-events/breaking.png";
import antImg from "../../images/fringe-events/ant.jpeg";
import yinImg from "../../images/fringe-events/yinyin.jpeg";

function Info() {
  const [expanded, setExpanded] = React.useState(false);

  const handleExpansion = () => {
    setExpanded((prevExpanded) => !prevExpanded);
  };

  return (
    <Container className="info" maxWidth="xl">
      <div className="info-content">
        <div className="text-section">
          <Typography className="title main-title" variant="h6">
            HEADS TALKING - FRINGE EVENTS
          </Typography>
        </div>
      </div>
      <div className="accordian-section">
        <Accordion
          expanded={expanded}
          onChange={handleExpansion}
          slots={{ transition: Fade }}
          slotProps={{ transition: { timeout: 400 } }}
          sx={[
            expanded
              ? {
                  [`& .${accordionClasses.region}`]: {
                    height: "auto",
                  },
                  [`& .${accordionDetailsClasses.root}`]: {
                    display: "block",
                  },
                }
              : {
                  [`& .${accordionClasses.region}`]: {
                    height: 0,
                  },
                  [`& .${accordionDetailsClasses.root}`]: {
                    display: "none",
                  },
                },
          ]}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <div className="text-section">
              <Typography className="title film-title" variant="h6">
                <span>14:30 -</span> GRASSROOTS MUSIC PANEL – MASTERING THE DIY
                SCENE.
              </Typography>
              <Typography className="text venue-title">
                Sandbar - Grosvenor St.
              </Typography>
              <Typography className="text hide-on-mobile">
                You need a FREE TICKET here to enter. No festival wristband
                required.
              </Typography>
              <Typography className="text hide-on-mobile">
                Emma Thompson (Fat Out, Sounds From The Other City).
                <br />
                Natalie Wardle (Loose Articles, Deaf & Gorilla).
                <br />
                Keith Miller (Wide Awake Festival, Bad Vibrations, Moth Club,
                Shacklewell Arms).
                <br />
                William Wolstenholme (BBC Introducing).
              </Typography>

              <Typography className="text more-info-btn hide-on-mobile">More Info</Typography>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <img
              src={grassrootImg}
              className="fringe-img"
              alt="Mastring the diy scene"
            />

            <Typography className="text">MASTERING THE DIY SCENE</Typography>
             <Typography className="text">
                You need a FREE TICKET here to enter. No festival wristband
                required.
              </Typography>
            <Typography className="text">
              Some first class industry advise for new artists, grassroots
              bands, and those keen to to make a stance in the DIY scenet.. Lots
              of topics will be covered and there will be a chance to ask some
              questions too.
            </Typography>
            <Typography className="text">
              This will help emerging musicians learn about:
            </Typography>
            <Typography className="text">
              Building your own scene – how local bands, promoters and venues
              and nurture a DIY scene. Working on a low budget. Role of social
              media & word of mouth. Making your own infrastructure.
            </Typography>
            <Typography className="text">
              Emma Thompson founded Fat Out in 2008 and is the Creative Director
              of From The Other. Fat Out are known for championing underground
              music and continually look to grow their collaborations with new
              musicians, artists and record labels.
            </Typography>
            <Typography className="text">
              Natalie Wardle is the vocalist and bassist for the female punk
              band Loose Articles. She is also the Marketing and Content Creator
              for Gorilla, Deaf Institute and Arts Club.
            </Typography>
            <Typography className="text">
              Keith Miller is the owner of LNZRT WRKS who are responsible for
              the programming, production and marketing at venues including The
              Moth Club, Shacklewell Arms and Studio9294. Some major acts they
              have programmed for include Four Tet, Lady Gaga and Idles. He is
              also the Co-founder and Festival Booker of Wide Awake Festival
              which takes place in Brockwell Park and is the owner of renown
              London promoters Bad Vibrations promotions.
            </Typography>
            <Typography className="text">
              William Wolstenholme is a presenter and producer of BBC
              Introducing in Lancashire and Cumbria. BBC Introducing are known
              for supporting new upcoming local artists and giving them a
              pathway to reaching various BBC platforms.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2-content"
            id="panel2-header"
          >
            <div className="text-section">
              <Typography className="title film-title" variant="h6">
                <span>16:00 -</span> GRASSROOTS MUSIC PANEL – BREAKING INTO THE
                MUSIC INDUSTRY.
              </Typography>

              <Typography className="text venue-title">
                Sandbar - Grosvenor St.
              </Typography>
              <Typography className="text hide-on-mobile">
                You need a FREE TICKET here to enter. No festival wristband
                required.
              </Typography>
              <Typography className="text hide-on-mobile">
                Jay Taylor (Music Venue Trust).
                <br />
                Deb Grant. (BBC 6 Music).
                <br />
                Bertie Gibbon (ATC Management – Future Islands, Sorry, WU LYF).
                <br />
                Roxane Dumoulin (ATC Live Agent – Lambrini Girls, Model/Actriz,
                Gilla Band, Sextile).
              </Typography>

              <Typography className="text more-info-btn hide-on-mobile">More Info</Typography>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <img
              src={masterImg}
              className="fringe-img"
              alt="Mastring the diy scene two"
            />
            <Typography className="text">
              BREAKING INTO THE MUSIC INDUSTRY
            </Typography>
                    <Typography className="text">
                You need a FREE TICKET here to enter. No festival wristband
                required.
              </Typography>
            <Typography className="text">
              Some first class industry advice for new artists, grassroots
              bands, and those keen to take the next steps in their music
              career. Lots of topics will be covered and there will be a chance
              to ask some questions too.
            </Typography>
            <Typography className="text">
              The panel will be based on helping new musicians with basics of
              starting out and tips:
            </Typography>
            <Typography className="text">
              Topics such as getting gigs, self-promo, understanding the music
              industry, touring intel, online presence & social media, help with
              arts grants, ethical sponsorship and branding opportunities,
              career paths onto music roles, self-releasing music, community
              building and the importance of authenticity.
            </Typography>
            <Typography className="text">
              Jay Taylor currently works for the Music Venue Trust as the Music
              Venues Alliance Coordinator and is the Greater Manchester Music
              Commission Chair. He is the previous booker of the Night and Day
              Cafe and has been a lecturer at BIMM.
            </Typography>
            <Typography className="text">
              Deb Grant is a BBC Radio 6 broadcaster and has DJed at major
              festivals including Green Man and Love Supreme. She has also been
              a part of the judging committee for the Brit Awards and is a
              regular music columnist in the Big Issue.
            </Typography>
            <Typography className="text">
              Bertie Gibbon is an artist manager at ATC Management who
              represents Florence Sinclair, Future Islands, RIP Magic, Sorry,
              The Murder Capital and WU LYF. Previously he worked at Gross
              Management and Rough Trade Management with Paul Jones, managing
              artists including black midi and Shame.
            </Typography>
            <Typography className="text">
              Roxane Dumoulin is a booking agent at ATC Live and currently has
              artists such as Lambrini Girls, Los Bitchos, Model/Actriz and
              Sextile on her roster. She also represents Famous & Green Star who
              are playing this year’s Manchester Psych Fest.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3-content"
            id="panel3-header"
          >
            <div className="text-section">
              <Typography className="title film-title" variant="h6">
                <span>17:30 -</span> YIN YIN LIVE MASTERCLASS.
              </Typography>

              <Typography className="text venue-title">
                International Antony Burgess Foundation - Cambridge St.
              </Typography>
              <Typography className="text hide-on-mobile">
                You need a FREE TICKET here to enter. No festival wristband
                required.
              </Typography>
              <Typography className="text hide-on-mobile">
                Intimate Q and A Live session with YIN YIN hosting an
                exploration of their creative process, influences and
                songwriting.
              </Typography>

              <Typography className="text more-info-btn hide-on-mobile">More Info</Typography>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <img src={yinImg} className="fringe-img" alt="yin yin" />
            <Typography className="text">YIN YIN MASTERCLASS</Typography>
                 <Typography className="text">
                You need a FREE TICKET here to enter. No festival wristband
                required.
              </Typography>
            <Typography className="text">
              Join YIN YIN in a very intimate & special performance where they
              discuss their creative process, deconstruct their songwriting and
              how they draw from influences and make their own sound.
            </Typography>
            <Typography className="text">
              The band will also answer audience questions.
            </Typography>
            <Typography className="text">
              YĪN YĪN is a Dutch band known for their unique blend of
              psychedelic funk, disco, and Southeast Asian influences,
              particularly from the 1960s and 70s. Formed in Maastricht in 2017,
              the band initially consisted of Yves Lennertz, Kees Berkers, Remy
              Scheren, and Robbert Verwijlen. They gained recognition with their
              debut album, "The Rabbit That Hunts Tigers," in 2019 and have
              continued to release music exploring diverse sonic landscapes.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel4-content"
            id="panel4-header"
          >
            <div className="text-section">
              <Typography className="title film-title" variant="h6">
                <span>18:00 -</span> ANTONY SZMIEREK POETRY READING & ROADMAP BOOK
                SIGNING.
              </Typography>
              <Typography className="text venue-title">
                Sandbar - Grosvenor St.
              </Typography>
              <Typography className="text hide-on-mobile">
                Festival wristband holders only – limited capacity – first come,
                first serve.
              </Typography>
              <Typography className="text hide-on-mobile">
                Manchester legend and friend of the festival Antony Smzierek
                will be here in the flesh to sign copies of his book roadmap
                whilst expressing his lyrical talent with some poetry.
              </Typography>

              <Typography className="text more-info-btn hide-on-mobile">More Info</Typography>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <img src={antImg} className="fringe-img" alt="Anthony" />
            <Typography className="text">
              ANTONY SZMIEREK POETRY READING & ROADMAP BOOK SIGNING
            </Typography>
                  <Typography className="text">
                Festival wristband holders only – limited capacity – first come,
                first serve.
              </Typography>
            <Typography className="text">
              Manchester-based poet, writer and producer Antony Szmierek rose to
              prominence on the Manchester spoken word scene with his 2023
              single “The Hitchhiker’s Guide to the Fallacy”.
            </Typography>
            <Typography className="text">
              His debut book *Roadmap*, launched at Hay Festival 2025, is a
              hyper-visual experience, packed with exclusive material.
            </Typography>
            <Typography className="text">
              It includes Szmierek’s debut album lyrics and an ‘exploded view’
              on the tracks, alongside additional poems, sketches and stories,
              presented as a full-colour paperback.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </div>
      <div className="info-content">
        <div className="text-section">
          <Typography className="title main-title" variant="h6">
            In association with Arts Council England, Brighter Sound & Oxford Rd
            Corridor.
          </Typography>
        </div>
      </div>
    </Container>
  );
}
export default Info;
